import { Card, CardContent, Typography, useMediaQuery } from '@mui/material';
import { CustomerAnalyticsStyles } from './CustomerAnalyticsStyles';
import { useAppSelector } from '../../store/hooks';
import { RootState } from '../../store/store';
import CustomSkeleton from '../../common/CustomSkeleton/CustomSkeleton';

export interface ISummaryCardProps {
  selectedAnalyticsType: number
}
const SummaryCard:React.FC<ISummaryCardProps> = ({selectedAnalyticsType}) => {
    const isMobile = useMediaQuery("(max-width:767px)");
  
  const {totalCount} = useAppSelector((state:RootState)=>state.customerAnalytics)
  const { isLoading } = useAppSelector(
    (state: RootState) => state.common
  );
 return( 
 <Card sx={{...CustomerAnalyticsStyles.summaryCard,
        width: isMobile ? "100%" : "40vw",
        maxWidth: isMobile ? "calc(100vw - 40px)" : "none"
        }}>
    <CardContent>
      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
        Total Activities
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: 'bold', marginY: 1 }}>
        {isLoading ?  
          <CustomSkeleton variant='text' count={1} height={"30px"}/>
        : totalCount || 0}
      </Typography>
      <Typography variant="body2" color="text.secondary">
       { selectedAnalyticsType=== 0 ? "All claims activities":"All policy change activities"}
      </Typography>
    </CardContent>
  </Card>
);
}

export default SummaryCard; 